import $ from 'jquery';

const options = {
  modalClose: '.js-modal-close',
  Yoffset: 0,
};

const init = () => {
  $('.js-launch-tooltip').on('click', (e) => {
    e.preventDefault();
    let $target = $(e.currentTarget);
    let title = $target.data('tooltip-title');
    let copy = $target.data('tooltip-copy');
    let jargon = $target.data('tooltip-jargon');
    let jargonCta = $target.data('tooltip');
    showModal(title, copy, jargon, jargonCta);
  });

  $(options.modalClose).click(function () {
    removeModal();
  });
};

const showModal = (title, copy, jargon, jargonCta) => {
  options.Yoffset = $(window).scrollTop();
  $('.js-modal-tooltip h1').text(title);
  $('.js-modal-tooltip p').text(copy);
  if (jargon.toLowerCase() === 'true') {
    $('.modal-inner div').addClass('jargon');
  }
  $('.modal-cta').html(jargonCta);
  $('.js-modal-tooltip').addClass('modal-animating');

  setTimeout(function () {
    $('html').css({
      position: 'fixed',
      'overflow-y': 'scroll',
      width: '100%',
      top: '-=' + options.Yoffset,
      right: '0',
      bottom: '0',
      left: '0',
    });
    $('html').addClass('modal-active');
  }, 100);

  document.addEventListener('keyup', escapeListener);
  $('.modal-active .modal-close').focus();
};

const escapeListener = (event) => {
  if (event.defaultPrevented) {
    return;
  }

  let key = event.key || event.keyCode;

  if (key === 'Escape' || key === 'Esc' || key === 27) {
    removeModal();
  }
};

const removeModal = () => {
  $('html').removeClass('modal-active');
  $('.modal-inner div').removeClass('jargon');

  setTimeout(function () {
    $('html').css({
      position: '',
      'overflow-y': '',
      width: '',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
    });
    window.scrollTo(0, options.Yoffset);
    $('.js-modal-tooltip').removeClass('modal-animating');
  }, 100);

  document.removeEventListener('keyup', escapeListener);
};

export { init };
